import React, { FC } from 'react';

import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const CloseIcon: FC<Props> = props => <AbstractIcon {...props} icon={faXmark} />;

export { CloseIcon };